import React from 'react';
import PropTypes from 'prop-types';

const CheckedMarkSVGR = ({ className }) => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    className={className}
  >
    <path fill='#19a683' d='M9 0C4 0 0 4 0 9s4 9 9 9 9-4 9-9-4-9-9-9z' />
    <path
      fill='#fff'
      d='M13.703 7.559l-4.646 4.174a1.07 1.07 0 01-.718.267 1.08 1.08 0 01-.72-.267L5.298 9.646a.851.851 0 010-1.292 1.107 1.107 0 011.438 0L8.34 9.796l3.927-3.528a1.1 1.1 0 011.438 0 .852.852 0 010 1.29z'
    />
  </svg>
);

CheckedMarkSVGR.propTypes = {
  className: PropTypes.string,
};

CheckedMarkSVGR.defaultProps = {
  className: '',
};

export default CheckedMarkSVGR;
